export default {
  NOT_EVALUATED: 0,
  APPROVED: 1,
  REPROVED: 2,
};
